import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { RTU } from "../../types/RTU";
import { formatProducerName } from "../../utils/rtuDefaults";
import { normalizeOperationalStatus } from "../../utils/statusConfig";

interface PopupProps {
  rtus: RTU[];
  onClose: () => void;
}

const PopupComponent: React.FC<PopupProps> = ({ rtus, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openRtuDetail = (event: any) => {
    const rtuId = event.data.id;
    const rtu = rtus.find((item) => item.id === rtuId);
    navigate(`/rtupage/${rtuId}`, { state: { rtu } });
  };

  return (
    <Dialog
      header={t("dashboard.popups.totalDevices.title", {
        status: t(`status.${normalizeOperationalStatus(rtus[0]?.status)}`),
      })}
      visible
      className="dashboard-status-detail-dialog"
      style={{ width: "min(64rem, calc(100vw - 7rem))", maxWidth: "96vw" }}
      contentStyle={{ padding: "0.75rem 1rem 1rem" }}
      headerStyle={{ padding: "0.75rem 1rem", borderBottom: "1px solid #e9ecef" }}
      modal
      onHide={onClose}
      blockScroll
    >
      <DataTable
        value={rtus}
        onRowClick={openRtuDetail}
        rowClassName={() => "dashboard-status-detail-dialog__row"}
        tableStyle={{ width: "100%", tableLayout: "fixed" }}
        scrollHeight="360px"
        scrollable
        showGridlines
        size="small"
        stripedRows
      >
        <Column
          field="id"
          header={t("dashboard.tables.columns.wellId", { defaultValue: "Well ID" })}
          style={{ width: "7rem" }}
          bodyStyle={{ textAlign: "center" }}
        />
        <Column
          field="name"
          header={t("dashboard.tables.columns.rtuId", { defaultValue: "RTU ID" })}
          style={{ width: "40%" }}
        />
        <Column
          field="provider"
          header={t("dashboard.tables.columns.producer")}
          style={{ width: "40%" }}
          body={(row: RTU) => formatProducerName(row.provider)}
        />
      </DataTable>
    </Dialog>
  );
};

export default PopupComponent;
